"use client";
import { jsxs as t, jsx as m } from "react/jsx-runtime";
import { useTooltip as x } from "../../hooks/useTooltip/useTooltip.mjs";
function h(s) {
  const { children: e, label: o, className: r, style: p, showArrow: a, ...l } = s, { isOpen: i, getTriggerProps: n, getTooltipProps: d, getArrowProps: c } = x(l);
  return /* @__PURE__ */ t("span", { ...n({ className: r, style: p }), "data-testid": "tooltip", children: [
    e,
    o && i && /* @__PURE__ */ t(
      "div",
      {
        ...d({
          role: "tooltip",
          className: "bg-black px-2 py-1.5 rounded-md text-white text-xs w-max max-w-[360px] drop-shadow"
        }),
        children: [
          o,
          a && /* @__PURE__ */ m("span", { ...c({ className: "bg-black rotate-45" }) })
        ]
      }
    )
  ] });
}
export {
  h as default
};
